import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

// import { dayjs } from '@ui';

import { layoutSlice } from './layout';
import { productSlice } from './product';
import { TermQuoteStoreState } from './types';
import { userSlice } from './user';

export const useTermQuoteStore = create<TermQuoteStoreState>()(
  immer(
    devtools((...a) => ({
      ...userSlice(...a),
      ...productSlice(...a),
      ...layoutSlice(...a)
    }))
  )
);

// Enable for testing only
// useTermQuoteStore.setState((state) => {
//   state.plan = {
//     ...state.plan,
//     fullName: '',
//     dob: dayjs('07-02-1995', 'DD-MM-YYYY'),
//     gender: 'Female',
//     tobacco: false,
//     diabetic: false,
//     annInc: 1000000,
//     mExpenses: 20000,
//     pincode: 673317,
//     salaried: true,
//     education: 'graduate',
//     isNRI: false,
//     cover: 1_30_000_00,
//     paymentFreq: 'Yearly',
//     payOption: 'limited5',
//     mobile: '',
//     nriCountry: '',
//     gstWaiver: false,
//     // product: TERM_INSURANCE_PRODUCTS.I_PROTECT_SMART_PLUS,
//     tillAge: 78
//   };
//   state.derived = {
//     ...state.derived,
//     age: 29
//   };
// });
